import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Dialog } from "@natera/material/lib/dialog";
import { Button } from "@natera/form";

import "./dobHelpDialog.scss";

const SUPPORT_EMAIL = "portalsupport@natera.com";

const messages = defineMessages({
  dobHelpDialogTitle: {
    id: "dobHelpDialogTitle",
    defaultMessage: "Editing your date of birth",
  },
  dobHelpDialogBody: {
    id: "dobHelpDialogBody",
    defaultMessage:
      "To protect your health information, we do not allow patients to edit their date of birth online. Please email <link>{email}</link> to get in touch with our patient experience team, who can make the necessary changes.",
  },
  dobHelpDialogEmailLinkAriaLabel: {
    id: "dobHelpDialogEmailLinkAriaLabel",
    defaultMessage:
      "Email patient experience team at {email} to update your date of birth",
  },
  dobHelpDialogClose: {
    id: "dobHelpDialogClose",
    defaultMessage: "Close",
  },
});

type Props = {
  onClose: () => void;
};

const DobHelpDialog: FC<Props> = ({ onClose }) => {
  const intl = useIntl();

  return (
    <Dialog
      className="dob-help-dialog"
      onClose={onClose}
      showCrossButton
      title={intl.formatMessage(messages.dobHelpDialogTitle)}
      actions={
        <Button unelevated onClick={onClose}>
          {intl.formatMessage(messages.dobHelpDialogClose)}
        </Button>
      }
    >
      <p className="dob-help-dialog__body">
        {intl.formatMessage(messages.dobHelpDialogBody, {
          email: SUPPORT_EMAIL,
          link: (chunks) => (
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              aria-label={intl.formatMessage(
                messages.dobHelpDialogEmailLinkAriaLabel,
                { email: SUPPORT_EMAIL }
              )}
            >
              {chunks}
            </a>
          ),
        })}
      </p>
    </Dialog>
  );
};

export default DobHelpDialog;
